import React, { FunctionComponent } from 'react';
import { faChartBar } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconChart: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faChartBar} />;

export { BrassIconChart };
